export default "__VITE_ASSET__BLgUm3A6__"